import React from 'react';
import { Card, Button } from '@ncoder/ui';
import { Rocket, Settings, Eye } from 'lucide-react';

interface QuickActionsPanelProps {
  onQuickDeploy: () => void;
  onConfiguration: () => void;
  onViewLiveAgent: () => void;
}

export const QuickActionsPanel: React.FC<QuickActionsPanelProps> = ({
  onQuickDeploy,
  onConfiguration,
  onViewLiveAgent,
}) => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Quick Actions</h3>
      <div className="space-y-3">
        <Button
          variant="default"
          className="w-full justify-start"
          onClick={onQuickDeploy}
        >
          <Rocket className="mr-2 h-4 w-4" />
          Quick Deploy
        </Button>
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={onConfiguration}
        >
          <Settings className="mr-2 h-4 w-4" />
          Configuration
        </Button>
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={onViewLiveAgent}
        >
          <Eye className="mr-2 h-4 w-4" />
          View Live Agent
        </Button>
      </div>
    </Card>
  );
};
